
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Challenge from "./pages/Challenge";
import Results from "./pages/Results";
import Profile from "./pages/Profile";
import NotFound from "./pages/NotFound";
import React, { useEffect, useState } from "react";
import { InstallTutorialModal } from "@/components/InstallTutorialModal";

const queryClient = new QueryClient();

const App = () => {
  // Show tutorial modal for first-time users
  const [showTutorial, setShowTutorial] = useState(false);

  useEffect(() => {
    // Only show on iOS Safari - detect user agent
    const isIOS = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    const isInStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      // @ts-ignore - "standalone" is only on iOS Safari
      (window.navigator as any).standalone;
    const seenTutorial = localStorage.getItem("ff_tutorial_seen");
    if (isIOS && !isInStandalone && !seenTutorial) {
      setShowTutorial(true);
    }
  }, []);

  const handleCloseTutorial = () => {
    setShowTutorial(false);
    localStorage.setItem("ff_tutorial_seen", "1");
  };

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        {showTutorial && (
          <InstallTutorialModal open={showTutorial} onClose={handleCloseTutorial} />
        )}
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/challenge" element={<Challenge />} />
            <Route path="/results" element={<Results />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
